<template>
  <img
    v-if="src"
    :src="src"
    :alt="alt"
    class="media-thumb"
    :style="sizeStyle"
    @error="handleImgError"
  />
  <div v-else class="media-thumb media-thumb-placeholder" :style="sizeStyle">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="m21 15-5-5L5 21" />
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { handleImgError } from '@/helpers/utils';

const props = withDefaults(
  defineProps<{
    src?: string | null;
    alt?: string;
    size?: number;
  }>(),
  { size: 56, alt: '' },
);

const sizeStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>

<style scoped>
.media-thumb {
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.media-thumb-placeholder {
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.media-thumb-placeholder svg {
  width: 20px;
  height: 20px;
  color: #9ca3af;
}
</style>
